import React from 'react';
import { Box, Skeleton } from '@mui/material';

const DaySkeleton = (): JSX.Element => (
  <>
    <Box width={1} mb={2}>
      <Skeleton width="100%" height={48} />
    </Box>
    <Box width={1} mb={2}>
      <Skeleton width="100%" height={48} />
    </Box>
    <Box width={1} mb={2}>
      <Skeleton width="100%" height={48} />
    </Box>
    <Box width={1} mb={2}>
      <Skeleton width="100%" height={48} />
    </Box>
    <Box width={1} mb={2} textAlign="center">
      <Skeleton width="50%" height={24} />
    </Box>
  </>
);

export default DaySkeleton;
